const API_BASE = (import.meta as any).env?.VITE_API_BASE_URL || '/api'

export type News = {
  id: number
  title: string
  summary?: string
  imageUrl?: string
  category?: string
  createdAt?: string
}

export async function fetchLatestNews(limit = 6): Promise<News[]> {
  try {
    const params = new URLSearchParams({ status: 'published', page: '0', size: String(limit), sort: 'createdAt,desc' })
    const res = await fetch(`${API_BASE}/news/page?${params.toString()}`)
    if (!res.ok) throw new Error('news load failed')
    const data = await res.json()
    return data?.content || []
  } catch {
    return []
  }
}

export type Page<T> = { content: T[]; totalElements: number }

export async function pageNews(params: { page?: number; size?: number; sort?: string; q?: string; category?: string } = {}): Promise<Page<News>> {
  const p = new URLSearchParams()
  p.set('status', 'published')
  if (params.page != null) p.set('page', String(params.page))
  if (params.size != null) p.set('size', String(params.size))
  p.set('sort', params.sort || 'createdAt,desc')
  if (params.q) p.set('q', params.q)
  if (params.category) p.set('category', params.category)
  const res = await fetch(`${API_BASE}/news/page?${p.toString()}`)
  if (!res.ok) throw new Error('news page failed')
  return res.json()
}
